import { useState, useEffect } from "react";
import * as firebase from "firebase";
import { parseDocSnapshot } from "./utils";

export function useFirestoreDoc(collectionName, where) {
  const [doc, setDoc] = useState();
  useEffect(() => {
    return where(firebase.firestore().collection(collectionName)).onSnapshot(
      snapshot => {
        setDoc(snapshot.docs[0] && parseDocSnapshot(snapshot.docs[0]));
      }
    );
  }, [collectionName, where]);

  return doc;
}
